import ui from "./ui.js";
import materials from "./materials.js";
import * as THREE from "three";


export default function options(model, originalMaterial, scene, camera){
    const {mainRadios, equipmentCheckbox, materialRadios, islandRadios} = ui()
    let firstLoadForMain = true
    let firstLoadForMaterial = true
    const priceValue = document.querySelector('.price-value')

    const defaultPrice = 6000

    const { materialWoodLight, materialWoodMedium} = materials(scene)
    const urlParams = new URLSearchParams(window.location.search);

    const mainParam = urlParams.get('main');
    const materialsParam = urlParams.get('materials');



    mainRadios.forEach((item)=>{
        if (mainParam === item.value && firstLoadForMain) {
            item.checked = true
            changeColor(mainParam)
            firstLoadForMain = false
        }

        item.addEventListener('change', event => {
            changeColor(event.target.value)
        });



    })

    // function changeColor(hex) {
    //
    //     scene.traverse((child) => {
    //         if (!child.isMesh || !child.material) return
    //         const mats = Array.isArray(child.material) ? child.material : [child.material]
    //         mats.forEach(mat => {
    //             if (!mat.name) return
    //             const name = mat.name.toLowerCase()
    //
    //             if (name.includes('panelblack')) {
    //                 mat.color.set(hex)
    //
    //                 mat.needsUpdate = true
    //             }
    //         })
    //     })
    // }

    function changeColor(hex) {
        const targetColor = new THREE.Color(hex);
        const duration = 1000; // берём из GUI
        const startTime = performance.now();

        const materials = [];
        scene.traverse((child) => {
            if (!child.isMesh || !child.material) return;
            const mats = Array.isArray(child.material) ? child.material : [child.material];
            mats.forEach(mat => {
                if (!mat.name) return;
                const name = mat.name.toLowerCase();
                if (name.includes('panelblack')) {
                    materials.push({
                        mat,
                        startColor: mat.color.clone()
                    });
                }
            });
        });

        function animate() {
            const elapsed = performance.now() - startTime;
            const t = Math.min(elapsed / duration, 1);
            const eased = t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

            materials.forEach(({ mat, startColor }) => {
                mat.color.copy(startColor).lerp(targetColor, eased);
                mat.needsUpdate = true;
            });

            if (t < 1) requestAnimationFrame(animate);
        }

        animate();
    }


    // equipmentCheckbox.forEach((item)=>{
    //     item.addEventListener('change', event => {
    //         changeEquipment(event.target.dataset.text, event.target.checked)
    //     });
    //
    //     function changeEquipment(data, value){
    //         calculatePrice()
    //
    //         model.traverse( (child) => {
    //
    //             switch (data) {
    //                 case 'Corner':
    //                     if (child.name.toLowerCase().includes('corner')) {
    //                         child.visible = true
    //                     }
    //
    //                     if (child.name.toLowerCase().includes('straight')) {
    //                         child.visible = false
    //                     }
    //
    //                     if (child.name.toLowerCase().includes('bar')) {
    //                         child.visible = false
    //                     }
    //                     break;
    //
    //                 case 'Straight':
    //                     if (child.name.toLowerCase().includes('corner')) {
    //                         child.visible = false
    //                     }
    //
    //                     if (child.name.toLowerCase().includes('straight')) {
    //                         child.visible = true
    //                     }
    //
    //                     if (child.name.toLowerCase().includes('bar')) {
    //                         child.visible = false
    //                     }
    //                     break;
    //
    //                 case 'Bar':
    //                     if (child.name.toLowerCase().includes('corner')) {
    //                         child.visible = false
    //                     }
    //
    //                     if (child.name.toLowerCase().includes('straight')) {
    //                         child.visible = false
    //                     }
    //
    //                     if (child.name.toLowerCase().includes('bar')) {
    //                         child.visible = true
    //                     }
    //                     break;
    //             }
    //         });
    //     }
    // })

    function fadeOut(meshes, duration = 300) {
        return new Promise(resolve => {
            if (meshes.length === 0) return resolve();
            const startTime = performance.now();

            meshes.forEach(mesh => {
                mesh.traverse(child => {
                    if (!child.isMesh) return;
                    const mats = Array.isArray(child.material) ? child.material : [child.material];
                    mats.forEach(mat => {
                        mat.transparent = true;
                        mat.opacity = 1;
                        mat.needsUpdate = true;
                    });
                });
            });

            function animate() {
                const t = Math.min((performance.now() - startTime) / duration, 1);

                meshes.forEach(mesh => {
                    mesh.traverse(child => {
                        if (!child.isMesh) return;
                        const mats = Array.isArray(child.material) ? child.material : [child.material];
                        mats.forEach(mat => { mat.opacity = 1 - t; mat.needsUpdate = true; });
                    });
                });

                if (t < 1) {
                    requestAnimationFrame(animate);
                } else {
                    meshes.forEach(mesh => { mesh.visible = false; });
                    resolve();
                }
            }

            animate();
        });
    }

    function fadeIn(meshes, duration = 300) {
        return new Promise(resolve => {
            if (meshes.length === 0) return resolve();
            const startTime = performance.now();

            meshes.forEach(mesh => {
                mesh.visible = true;
                mesh.traverse(child => {
                    if (!child.isMesh) return;
                    const mats = Array.isArray(child.material) ? child.material : [child.material];
                    mats.forEach(mat => {
                        mat.transparent = true;
                        mat.opacity = 0;
                        mat.needsUpdate = true;
                    });
                });
            });

            function animate() {
                const t = Math.min((performance.now() - startTime) / duration, 1);

                meshes.forEach(mesh => {
                    mesh.traverse(child => {
                        if (!child.isMesh) return;
                        const mats = Array.isArray(child.material) ? child.material : [child.material];
                        mats.forEach(mat => { mat.opacity = t; mat.needsUpdate = true; });
                    });
                });

                if (t < 1) {
                    requestAnimationFrame(animate);
                } else {
                    meshes.forEach(mesh => {
                        mesh.traverse(child => {
                            if (!child.isMesh) return;
                            const mats = Array.isArray(child.material) ? child.material : [child.material];
                            mats.forEach(mat => {
                                mat.transparent = false;
                                mat.opacity = 1;
                                mat.needsUpdate = true;
                            });
                        });
                    });
                    resolve();
                }
            }

            animate();
        });
    }

    equipmentCheckbox.forEach((item) => {
        item.addEventListener('change', event => {
            changeEquipment(event.target.dataset.text, event.target.checked);
        });

        async function changeEquipment(data, value) {
            calculatePrice();

            const visibilityMap = {
                Corner:   { corner: true,  straight: false, bar: false },
                Straight: { corner: false, straight: true,  bar: false },
                Bar:      { corner: false, straight: false,  bar: true  },
            };

            const rules = visibilityMap[data];
            if (!rules) return;

            const groups = { corner: [], straight: [], bar: [] };
            model.traverse(child => {
                const name = child.name.toLowerCase();
                for (const key in groups) {
                    if (name.includes(key)) groups[key].push(child);
                }
            });

            // Сначала скрываем всё что должно уйти
            const toHide = Object.keys(rules)
                .filter(key => !rules[key])
                .flatMap(key => groups[key]);

            const toShow = Object.keys(rules)
                .filter(key => rules[key])
                .flatMap(key => groups[key]);

            // Ждём пока старое уйдёт — потом показываем новое
            await fadeOut(toHide);
            await fadeIn(toShow);
        }
    });



    // islandRadios.forEach((item)=>{
    //     item.addEventListener('change', event => {
    //         changeEquipment(event.target.dataset.text, event.target.checked)
    //     });
    //
    //     function changeEquipment(data, value){
    //         calculatePrice()
    //
    //         model.traverse( (child) => {
    //
    //             if (child.name === 'island') {
    //                 child.visible = value
    //             }
    //
    //         });
    //     }
    // })

    islandRadios.forEach((item) => {
        item.addEventListener('change', event => {
            calculatePrice();

            const value = event.target.checked;
            const duration = 300;
            const startTime = performance.now();

            // берём только первый island
            let island = null;
            model.traverse(child => {
                if (child.name === 'island' && !island) island = child;
            });

            if (!island) return;

            island.visible = true;

            const meshData = [];
            // traverse только прямых детей island, не всей сцены
            island.children.forEach(child => {
                if (!child.isMesh) return;
                const originalMat = child.material;
                const clone = originalMat.clone();
                clone.transparent = true;
                clone.opacity = value ? 0 : 1;
                clone.needsUpdate = true;
                child.material = clone;
                meshData.push({ child, originalMat, clone });
            });

            function animate() {
                const t = Math.min((performance.now() - startTime) / duration, 1);

                meshData.forEach(({ clone }) => {
                    clone.opacity = value ? t : 1 - t;
                    clone.needsUpdate = true;
                });

                if (t < 1) {
                    requestAnimationFrame(animate);
                } else {
                    meshData.forEach(({ child, originalMat }) => {
                        child.material = originalMat;
                    });
                    if (!value) island.visible = false;
                }
            }

            animate();
        });
    });


    materialRadios.forEach((item)=>{
        if (materialsParam === item.value && firstLoadForMaterial) {
            item.checked = true
            changeMaterial(materialsParam)
            firstLoadForMaterial = false
        }

        item.addEventListener('change', event => {
            changeMaterial(event.target.value)
        })


    })

    // function changeMaterial(data){
    //     calculatePrice()
    //
    //
    //     model.traverse( (child) => {
    //         if (child.isMesh) {
    //
    //             if (child.material.name === 'woodPanelMiddle') {
    //                 if (data === 'default'){
    //                     child.material = originalMaterial
    //                     child.material.name = 'woodPanelMiddle'
    //                 }
    //
    //
    //
    //                 if (data === 'light'){
    //                     child.material = materialWoodLight
    //                     child.material.name = 'woodPanelMiddle'
    //                 }
    //
    //                 if (data === 'medium'){
    //                     child.material = materialWoodMedium
    //                     child.material.name = 'woodPanelMiddle'
    //                 }
    //             }
    //         }
    //     })
    // }

    function changeMaterial(data) {
        calculatePrice();
        const materialMap = {
            default: originalMaterial,
            light: materialWoodLight,
            medium: materialWoodMedium,
        };
        const targetMaterial = materialMap[data];
        if (!targetMaterial) return;

        const duration = 600;
        const startTime = performance.now();

        const meshes = [];
        model.traverse((child) => {
            if (!child.isMesh) return;
            const mats = Array.isArray(child.material) ? child.material : [child.material];
            mats.forEach(mat => {
                if (mat.name === 'woodPanelMiddle') meshes.push(child);
            });
        });

        // Сохраняем старые материалы
        const oldMaterials = meshes.map(mesh => mesh.material);

        // Создаём новые материалы (начинаем с opacity=0)
        const newMaterials = meshes.map(() => {
            const clone = targetMaterial.clone();
            clone.name = 'woodPanelMiddle';
            clone.transparent = true;
            clone.opacity = 0;
            return clone;
        });

        // Старые делаем transparent чтобы можно было менять opacity
        oldMaterials.forEach(mat => {
            mat.transparent = true;
            mat.opacity = 1;
            mat.needsUpdate = true;
        });

        // Используем многослойность через массив материалов или отдельный проход
        // Проще всего: рендерим оба меша — клонируем меш для старого слоя
        const ghostMeshes = meshes.map((mesh, i) => {
            const ghost = mesh.clone();
            ghost.material = oldMaterials[i];
            ghost.name = '__ghost__';
            mesh.parent.add(ghost);
            return ghost;
        });

        // Назначаем новый материал основному мешу
        meshes.forEach((mesh, i) => {
            mesh.material = newMaterials[i];
            mesh.material.needsUpdate = true;
        });

        function animate() {
            const elapsed = performance.now() - startTime;
            const t = Math.min(elapsed / duration, 1);

            // Новый появляется
            newMaterials.forEach(mat => {
                mat.opacity = t;
                mat.needsUpdate = true;
            });

            // Старый исчезает
            ghostMeshes.forEach(ghost => {
                ghost.material.opacity = 1 - t;
                ghost.material.needsUpdate = true;
            });

            if (t < 1) {
                requestAnimationFrame(animate);
            } else {
                // Финализируем
                meshes.forEach(mesh => {
                    mesh.material.opacity = 1;
                    mesh.material.transparent = false;
                    mesh.material.needsUpdate = true;
                });

                // Убираем ghost-меши
                ghostMeshes.forEach(ghost => {
                    ghost.parent.remove(ghost);
                    ghost.material.dispose();
                });
            }
        }

        animate();
    }

    function calculatePrice(){
        let price = defaultPrice

        mainRadios.forEach((item)=>{
            if (item.checked){
                price += +item.dataset.price
            }
        })

        islandRadios.forEach((item)=>{
            if (item.checked){
                price += +item.dataset.price
            }
        })


        equipmentCheckbox.forEach((item)=>{
            if (item.checked){
                price += +item.dataset.price
            }
        })

        priceValue.textContent = price

    }
}